import React from 'react';
import NoSSR from 'react-no-ssr';
import styles from './index.css';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import RecommendList from './recommendList';
import AreaStaticChip from '@ifeng-fe/container_content/common/client/components/areaStaticChip';

class PicOver extends React.PureComponent {
    static propTypes = {
        handleOverPrev: PropTypes.func,
        handleOverNext: PropTypes.func,
        picOverData: PropTypes.object,
        lastAd: PropTypes.string,
    };

    // 再次浏览
    handleRevisit = () => {
        window.location.href = window.location.href.split('#')[0];
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            handleOverPrev,
            handleOverNext,
            picOverData: { chipObj, recommend },
            lastAd,
        } = this.props;

        return (
            <div className={styles.over}>
                <a className={styles.overprev} onClick={handleOverPrev}>
                    <span>上一页</span>
                </a>
                <a className={styles.overnext} onClick={handleOverNext}>
                    <span>下一图集</span>
                </a>
                <div className={styles.overCon}>
                    <div className={styles.overTit}>
                        <div className={styles.tip}>图集已浏览完毕</div>
                        <div className={styles.readAgin} onClick={this.handleRevisit}>
                            再次浏览<span />
                        </div>
                        <div className={styles.readNext} onClick={handleOverNext}>
                            下一图集<span />
                        </div>
                    </div>
                    <Chip
                        id={chipObj.recommend}
                        type="recommend"
                        title="最后推荐"
                        groupName="最后一屏"
                        translate="handleInfoAd"
                        content={recommend}>
                        <RecommendList />
                    </Chip>
                    <div className="clear" />
                    <NoSSR>
                        <Chip
                            id={chipObj.lastAd}
                            type="static"
                            title="最后一屏广告"
                            groupName="最后一屏"
                            translate="handleAreaAd"
                            content={lastAd}>
                            <AreaStaticChip styleName={styles.last_box} />
                        </Chip>
                    </NoSSR>
                </div>
                <div className="bomAd" style={{ marginTop: '40px' }} />
            </div>
        );
    }
}

export default errorBoundary(PicOver);
